import InlineAlert from '../BaseComponents/Alert/InlineAlert'

// Issue #857 (item 4): extracted verbatim from Router.tsx (its only previous call site) so the
// same opaque "this page is unavailable" treatment can be reused by every signed-in shell that
// needs it (Router, OrganisationPickerLayout, VerifyEmailRequired, TrainingNotStarted) without
// re-implementing - and re-risking - the F6 security-review correction below.
function ConnectionLostOverlay() {
	return (
		<div
			// Issue #759 (final review F6): fully opaque (no /NN transparency). #889: in normal flow,
			// filling its container, so it replaces the hidden page rather than layering over it.
			className='flex min-h-full w-full items-start justify-center bg-charcoal-900 p-8'
			data-testid='connection-lost-overlay'
		>
			<InlineAlert type='warning' className='mt-12 max-w-md'>
				Connection lost. This page is unavailable until the connection is restored - the information behind this message may be out of date.
			</InlineAlert>
		</div>
	)
}

export default ConnectionLostOverlay
